<template>
  <div class="page-content">
    <div class="main-title">
      <p class="title green_text">
        <span class="no green_bg">
      <icon file="message-square" :size="24" />
    </span>
        <span>
          <strong> Commentaire au consultant en charge de l'étude </strong><br/>
      <small>(Visible uniquement lors de la modification de l'étude)</small>
        </span>
      </p>
    </div>
    <div class="comment">
      <el-textarea
        :parent_data="active_study.etudeData"
        property="editor_comment"
        :editable="true"
        height="185px"
        overflow_edit="hidden scroll"
        placeholder="Préciser"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "page-editor-comment",
	mixins: [PageMixin],
	computed: {
		...mapGetters(["active_study"]),
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';
</style>